<template>
  <div class="body-box marginBox2">
    <el-row class="plan" style="margin-bottom: 10px;"></el-row>

    <!--表单区域-->
    <el-form
      ref="addFormRef"
      :model="addForm"
      :rules="rules"
      label-width="140px"
      style="padding: 20px; background-color: #fff;"
    >
      <el-row>
        <!--商品名字-->
        <el-col :span="8">
          <el-form-item label="商品名字" prop="name">
            <el-input v-model="addForm.name" placeholder="请输入商品名字" />
          </el-form-item>
        </el-col>

        <!--数量-->
        <el-col :span="8">
          <el-form-item label="数量" prop="num">
            <el-input v-model="addForm.num" placeholder="请输入数量" />
          </el-form-item>
        </el-col>

        <!--分类字典-->
        <el-col :span="8">
          <el-form-item label="分类" prop="classifyId">
            <el-cascader
              style="width: 100%;"
              :options="classifyCheckList"
              @change="changeClassify"
              :props="props"
              v-model="addForm.classifyId"
              clearable></el-cascader>
          </el-form-item>
        </el-col>

        <!--品牌字典-->
        <el-col :span="8">
          <el-form-item label="品牌" prop="brandId">
            <el-select style="width: 100%;" v-model="addForm.brandId" placeholder="请选择">
              <el-option
                v-for="item in brandCheckList"
                :key="item.id"
                :label="item.value"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--相关排序-->
        <el-col :span="8">
          <el-form-item label="相关排序" prop="absort">
            <el-input v-model="addForm.absort" placeholder="请输入相关排序" />
          </el-form-item>
        </el-col>

        <!--首页排序-->
        <el-col :span="8">
          <el-form-item label="首页排序" prop="resort">
            <el-input v-model="addForm.resort" placeholder="请输入首页排序" />
          </el-form-item>
        </el-col>
        <!--VIP商品-->
        <el-col :span="8">
          <el-form-item label="是否是VIP商品" prop="vipFlag">
            <el-switch
              v-model="addForm.vipFlag"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0">
            </el-switch>
          </el-form-item>
        </el-col>

        <!--型号-->
        <el-col :span="24" style="padding: 0 140px 20px 140px;font-size: 20px;margin-top: 30px;">
          <span>型号</span>
          <span class="el-icon-circle-plus-outline" style="margin-left: 16px;cursor: pointer" @click="addFacility"></span>
        </el-col>

        <!--型号-->
        <el-col :span="24">
          <el-form label-width="140px">
            <div v-for="(item,index) in addForm.modeList" :key="index" class="shuttle_bus">
              <model-list :certifications='addForm.modeList' :index="index"></model-list>
            </div>
          </el-form>
        </el-col>

        <!--缩略图-->
        <el-col :span="24" class="label">
          <el-form-item label="缩略图">
            <thumbnail @getFiles="getThumbnailMd5"></thumbnail>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="上传视频">
            <!--<qq-video v-model="addForm.video"></qq-video>-->
            <qq-video-new v-model="addForm.video"></qq-video-new>
          </el-form-item>
        </el-col>

        <!--轮播图-->
        <el-col :span="24" class="label">
          <el-form-item label="轮播图">
            <thumbnail-list v-model="addForm.carousel"></thumbnail-list>
          </el-form-item>
        </el-col>

        <!--富文本-->
        <el-col :span="24" class="label">
          <el-form-item label="富文本">
            <editor ref="getAddEditor" v-model="addForm.brief" :type="'html'"></editor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="goBackBox">
      <el-button @click="goBack">返 回</el-button>
      <el-button @click="addGoods">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { addGoods } from '@/api/goods/goods'
import { getData } from '@/utils/code'
import { getDictsTree, selectDictByKey } from '@/api/user/dict/dict'
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import Editor from '@/components/common/editor/editor'
import ThumbnailList from '@/components/common/thumbnailList/thumbnailList'
import ModelList from '@/views/goods/modelList'
import QqVideoNew from '@/components/common/qqVideo/qqVideoNew'
import { goodsRules } from '@/js/rules'

export default {
  name: 'addGoods',
  components: { QqVideoNew, ModelList, ThumbnailList, Editor, Thumbnail },
  data() {
    return {
      addForm: {
        brandId: '', //品牌id
        classifyId: [], //分类id
        vipFlag: 0,
        modeList: [
          {
            amount: '',
            icon: '',
            integral: '',
            mode: '',
            score: '',
          }
        ]
      },
      props: {
        multiple: true,
        checkStrictly: true,
        emitPath: false,
        value: 'id',
        label: 'name',
      },
      rules: goodsRules,
      //初始化的值
      classifyCheckList: [],
      //初始化的值
      brandCheckList: [],
      queryClassifyInfo: {
        current: 1,
        size: 20,
        key: 'CLASSIFY'
      },
      queryBrandInfo: {
        current: 1,
        size: 20,
        key: 'BRAND'
      }
    }
  },
  created() {
    this.getClassify()
    this.getBrand()
  },
  methods: {
    //添加一行设施
    addFacility() {
      let obj = {
        amount: '',
        icon: '',
        integral: '',
        mode: '',
        score: '',
      }
      this.addForm.modeList.push(obj)
    },

    changeClassify() {
      let val = this.addForm.classifyId
      this.addForm.classifyId = val.join(',')
    },

    // 添加
    addGoods() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        let flag = true
        this.addForm.modeList.forEach(f => {
          if (!f.amount || !f.icon || !f.integral || !f.mode || !f.score) {
            return flag = false
          }
        })
        this.$refs.getAddEditor.getData()
        if (flag && this.addForm.thumbnail && this.addForm.classifyId && this.addForm.brandId && this.addForm.brief) {
          addGoods(this.addForm).then((response) => {
            let data = getData(response)
            if (data !== null) {
              this.$router.go(-1)
            }
          })
        }else {
          this.$message.error('请完善信息');
        }
      })
    },

    //返回
    goBack() {
      this.$router.go(-1)
    },

    //查询分类字典
    getClassify() {
      getDictsTree('CLASSIFY').then(res => {
        this.classifyCheckList = res.data
      })
    },

    //查询品牌字典
    getBrand() {
      this.getDictByKey(this.queryBrandInfo.key).then((result) => {
        this.brandCheckList = result
      })
    },

    //字典
    getDictByKey(query) {
      return new Promise((resolve, reject) => {
        selectDictByKey(query).then((response) => {
          let data = getData(response) ? getData(response) : []
          resolve(data)
        }).catch(() => {
          reject([])
        })
      })
    },

    //获取缩略图
    getThumbnailMd5(obj) {
      this.addForm.thumbnail = obj.md5
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-input {
  width: 90%;
}

/deep/ .shuttle_bus {
  position: relative;
  .location_box {
    position: absolute;
    top: 8px;
    right: 10px;
  }
}
/deep/.el-form-item__label:before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}
</style>
